<script lang="ts">import { RemoteIcon } from "@infinitro/icons";
let { size = 18 } = $props();
</script>

<RemoteIcon icon="VipIcon" {size} replaceFill color="black" />
